import { render, staticRenderFns } from "./CommonTips.vue?vue&type=template&id=8eb14410&scoped=true"
import script from "./CommonTips.vue?vue&type=script&lang=js"
export * from "./CommonTips.vue?vue&type=script&lang=js"
import style0 from "./CommonTips.vue?vue&type=style&index=0&id=8eb14410&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb14410",
  null
  
)

export default component.exports